export default __webpack_public_path__ + "static/media/earth-crop.156dc54f.png";